function loadedLocaleKey() {
    const l10ns = (window.flatpickr && window.flatpickr.l10ns) || {};
    const order = ['cs', 'sk', 'hr', 'pl', 'en'];
    for (const k of order) if (l10ns[k]) return k;
    return 'en';
}

function is24h(key) { return key !== 'en'; }

export function addDatepicker() {
    if (!window.flatpickr) return;
    const key = loadedLocaleKey();
    const opts = {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: key === 'en' ? 'F j, Y' : 'd.m.Y'
    };
    if (key !== 'en' && window.flatpickr.l10ns[key]) {
        opts.locale = window.flatpickr.l10ns[key];
    }
    window.flatpickr('[data-datepicker]', opts);
}

export function addTimepicker() {
    if (!window.flatpickr) return;
    const key = loadedLocaleKey();
    const use24 = is24h(key);
    const opts = {
        enableTime: true,
        noCalendar: true,
        time_24hr: use24,
        minuteIncrement: 15,
        dateFormat: use24 ? 'H:i' : 'h:i K'
    };
    if (key !== 'en' && window.flatpickr.l10ns[key]) {
        opts.locale = window.flatpickr.l10ns[key];
    }
    window.flatpickr('[data-timepicker]', opts);
}

export function initService() {
    addDatepicker();
    addTimepicker();
}